export function buildAgreementFormEntries(
  agreementDetail: Record<string, any>,
  skipKeys: string[]
): Array<[string, string]> {
  const entries: Array<[string, string]> = []

  Object.entries(agreementDetail).forEach(([key, value]) => {
    if (skipKeys.includes(key)) return
    if (value === null || value === undefined) return

    let formattedValue = value

    if (key === 'date_signed' && value === '') {
      formattedValue = 'XXXX-XX-XX'
    }

    if ((key === 'notification' || key === 'type' || key === 'iso') && Array.isArray(value)) {
      formattedValue = value.join(';')
    }

    if (key === 'crossregional' || key === 'parties_escap') {
      formattedValue = String(value).toLowerCase()
    }

    if (key === 'composition') {
      formattedValue = String(value).trim()
    }

    entries.push([key, String(formattedValue)])
  })

  return entries
}

export function getErrorMessage(err: any, fallback: string): string {
  return err?.response?.data?.message || fallback
}

export type AgreementSource = {
  id: string // local id (uuid / timestamp)
  alias: string
  link: string
}

export function parseSources(raw?: string): AgreementSource[] {
  if (!raw) return []

  return raw
    .split(';')
    .map((segment, index) => {
      const trimmed = segment.trim()
      if (!trimmed) return null

      if (trimmed.includes('|')) {
        const [alias, link] = trimmed.split('|')
        return {
          id: `${Date.now()}_${index}`,
          alias: alias || link,
          link,
        }
      }

      // legacy case: a plain URL with no alias|link pipe
      return {
        id: `${Date.now()}_${index}`,
        alias: trimmed,
        link: trimmed,
      }
    })
    .filter((source): source is AgreementSource => source !== null)
}
